import { clsx } from 'clsx';
import { baseInput, errorInput, errorTableInput, numberInput, tableInput } from './text-input.css';
import { ComponentPropsWithRef } from 'react';

export interface TextInputProps extends ComponentPropsWithRef<'input'> {
  error?: boolean;
  nativeNumberControls?: boolean;
  table?: boolean;
  css?: React.CSSProperties;
}

export const TextInput = (props: TextInputProps) => {
  const { error = false, nativeNumberControls = false, table = false, ref, css, ...rest } = props;
  const style: React.CSSProperties | undefined =
    props.type === 'number' && nativeNumberControls
      ? { WebkitAppearance: 'auto' as React.CSSProperties['WebkitAppearance'], ...css }
      : css;

  return (
    <input
      ref={ref}
      style={style}
      className={clsx(
        baseInput,
        props.type === 'number' && !nativeNumberControls && numberInput,
        error && errorInput,
        table && tableInput,
        error && table && errorTableInput,
      )}
      {...rest}
    />
  );
};
